<script>
  import { get, sync, call } from 'vuex-pathify'
  import { events } from '@/helpers/gtm'
  import SelectBoxCard from '@/components/subscribe/SelectBoxCard'
  import screen from '@/helpers/screen'
  import BaseSpinner from '@/components/base/BaseSpinner'
  import SubscribeSelectPlanFooter from './SubscribeSelectPlanFooter.vue'

  // import SubscribeWaitlistLandingPage from '@/components/subscribe/SubscribeWaitlistLandingPage'

  export default {
    components: {
      SelectBoxCard,
      BaseSpinner,
      SubscribeSelectPlanFooter,
    },
    data() {
      return {
        loading: true, // Add loading state
      }
    },
    computed: {
      ...get('config', ['isCurrentBoxWaitlist']),
      ...get('feature', ['flags']),
      ...get('account', ['isAlltruePlusSubscriber']),
      ...sync('subscribe', ['selectedBoxHandle']),
      ...get('prismic', ['getSubscribeBoxAndPlans']),
      screen,
      showAlltruePlus() {
        const isAllTruePlusEnabled = this.flags['alltrue-plus-option'] ?? false
        return isAllTruePlusEnabled && !this.isAlltruePlusSubscriber
      },
      planData() {
        return this.getSubscribeBoxAndPlans
      },
      boxCode() {
        return this.boxData?.product_code
      },
      boxTitle() {
        return this.boxData?.product_title || ''
      },
      boxDescription() {
        return this.boxData?.product_description || ''
      },
      boxPopular() {
        return this.boxData?.product_popular || ''
      },
      boxBenefitsSectionTitle() {
        return this.boxData?.benefits_section_title || ''
      },
      boxValuePrice() {
        return this.boxData?.value_price || ''
      },
      boxValueCustomizableChoice() {
        return this.boxData?.value_customizable_choice || ''
      },
      boxValueMembersMarketDeals() {
        return this.boxData?.value_members_market_deals || ''
      },
      boxButtonTextOverwrite() {
        if (this.boxData?.button_text_overwrite) {
          return this.boxData?.button_text_overwrite || ''
        }
        return 'Select this box'
      },
      boxButtonColor() {
        return this.boxData?.button_color || ''
      },
      boxPriceHeaderText() {
        if (this.boxData?.price_header_text) {
          return this.boxData?.price_header_text || ''
        }
        return 'Starting At'
      },
      boxPrice() {
        return this.boxData?.price || ''
      },
      boxImage() {
        return this.boxData?.main_product_image || ''
      },
      boxIllustration() {
        return this.boxData?.product_illustration_image || ''
      },
      boxColor() {
        return this.boxData?.product_color || ''
      },
      checkOrientation() {
        if (!this.screen.lg || this.orientation === 'vertical') {
          return true
        }
        return false
      },
    },
    async created() {
      this.loading = true
      try {
        await this.loadSubscriptionBoxandPlan()
        events.log({ name: 'viewed plan selection' })
        events.startSubscriptionCheckoutFunnel({ email: this.username })
        if (!this.isAlltruePlusSubscriber) {
          this.observeFlag('alltrue-plus-option')
        }
      } finally {
        this.loading = false
      }
    },
    methods: {
      ...call('feature', ['observeFlag']),
      ...call('prismic', ['loadSubscriptionBoxandPlan']),
      selectBox(boxHandle) {
        this.selectedBoxHandle = boxHandle
        events.log({
          name: 'selected Box',
          data: { plan: boxHandle },
        })
        // events.selectedSubscriptionPlan({
        //   email: this.username,
        //   boxHandle,
        // })
        this.$navigate({ name: 'SubscribePlan', params: { subscribe: 'SubscribePlan' } })
      },
    },
  }
</script>

<template>
  <div>
    <!-- <SubscribeWaitlistLandingPage v-if="isCurrentBoxWaitlist" @navigateToSubscribe="selectBox('alltrue')" /> -->
    <div class="mb-12">
      <!-- Banner with header -->
      <div class="bg-black text-dawn py-6 px-2 text-center text-sm leading-snug-tight mb-4">
        <h1 class="font-semibold text-base md:text-lg leading-snug-tight">
          Select Your Membership Type
        </h1>
        <p class="max-w-120 m-auto">
          Limited quantities available. Cancel anytime. Free shipping.*
        </p>
      </div>
      <div
        class="select-box-card-wrapper grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mx-auto px-3 md:px-6 max-w-320 items-start h-full justify-center"
      >
        <template v-for="(box, index) in planData">
          {{ box.primary.boxcode }}
          <SelectBoxCard
            v-if="box.primary.product_status"
            :key="index"
            :type="box.primary.product_type"
            :boxcode="box.primary.product_code"
            :boxtitle="box.primary.product_title"
            :boxdescription="box.primary.product_description"
            :boxpopular="box.primary.product_popular"
            :boxbenefitssectiontitle="box.primary.benefits_section_title"
            :boxvalueprice="box.primary.value_price"
            :boxvaluecustomizablechoice="box.primary.value_customizable_choice"
            :boxvaluemembersmarketdeals="box.primary.value_members_market_deals"
            :boxbuttontextvverwrite="box.primary.button_text_overwrite"
            :boxbuttoncolor="box.primary.button_color"
            :boxpriceheadertext="box.primary.price_header_text"
            :boxprice="box.primary.price"
            :boximage="box.primary.main_product_image"
            :boxillustration="box.primary.product_illustration_image"
            :boxcolor="box.primary.product_color"
            :checkorientation="box.primary.layout_orientation"
            @selectBox="selectBox(box.primary.product_code)"
          />
        </template>
      </div>
    </div>
    <SubscribeSelectPlanFooter />

    <!-- Add spinner -->
    <BaseSpinner v-if="loading" overlay="absolute" overlay-color="dawn-lt3" class="z-10" />
  </div>
</template>

<style lang="postcss" scoped>
  .max-width-two-cards {
    @apply px-3;

    @screen sm {
      @apply px-0;

      max-width: 404px;
    }

    @screen md {
      max-width: 476px;
    }

    @screen lg {
      max-width: 640px;
    }

    @screen xl {
      max-width: 728px;
    }
  }

  .max-width-three-cards {
    @apply px-3;

    @screen sm {
      @apply px-0;

      max-width: 612px;
    }

    @screen md {
      max-width: 720px;
    }

    @screen lg {
      max-width: 990px;
    }

    @screen xl {
      max-width: 1104px;
    }
  }
</style>
